<script>
import CMSSinglePage from "@/views/components/cms/CMSSinglePage.vue";

export default {
  name: "RentenClearUpSinglePage",
  components: {CMSSinglePage},
}
</script>

<template>
 <CMSSinglePage list-element="ClearUpList"></CMSSinglePage>
</template>

<style scoped>

</style>
